import CluppNumberRange from "../../../Components/CluppForms/CluppNumberRange";
import TitleHeaders from "../../../Components/CluppForms/TitleHeaders";

const RatingReferal = ({ state, setState, field }) => {
  const labels = {
    startLabel: "Muy improbable",
    middleLabel: "Probable",
    endLabel: "Definitivamente",
  };

  return (
    <>
      <TitleHeaders
        title={"¿Qué tan probable es que le recomiendes Clupp a alguien más?"}
        subtitle={
          "Por favor, selecciona una de las siguientes opciones de calificación."
        }
        isRequired={true}
      />
      <CluppNumberRange
        labels={labels}
        maxNumber={10}
        state={state}
        field={field}
        setState={setState}
      />
    </>
  );
};

export default RatingReferal;
